// extracted by mini-css-extract-plugin
export default {"category-card":"Categories_category-card__5wtH+","category-img":"Categories_category-img__pBOnX"};